"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.BannerMedia = void 0;
require("./BannerMedia.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actionFormatter = require("../../util/actionFormatter/actionFormatter");
var _getButtonHtml = require("../../util/getButtonHtml/getButtonHtml");
var _getLinkHtml = require("../../util/getLinkHtml/getLinkHtml");
var _renderObject = require("../../util/renderObject/renderObject");
var _BannerBody = _interopRequireDefault(require("../BannerBody/BannerBody"));
var _BannerFooter = _interopRequireDefault(require("../BannerFooter/BannerFooter"));
var _BannerHeader = _interopRequireDefault(require("../BannerHeader/BannerHeader"));
var _LoaderGhostCard = _interopRequireDefault(require("../LoaderGhostCard/LoaderGhostCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * BannerMedia component
 *
 * @method
 * @param { BannerMediaProps} props
 * @returns BannerMedia
 */

const BannerMedia = props => {
  const {
    borderColor = defaultProps.borderColor,
    elevation = defaultProps.elevation,
    actionGroups,
    body,
    bulletedList,
    cornerRadius = defaultProps.cornerRadius,
    externalAction,
    externalActionFullyClick,
    externalMedia,
    eyebrow,
    fullyClickableParent,
    headline,
    headlineTag = defaultProps.headlineTag,
    isLoading = defaultProps.isLoading,
    loaderHeightLg,
    loaderHeightMd,
    loaderHeightSm,
    loaderHeightXl,
    backgroundMedia,
    tag,
    textColor = defaultProps.textColor,
    textPosition = defaultProps.textPosition
  } = props;
  if (isLoading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pal-c-BannerMedia"
    }, /*#__PURE__*/_react.default.createElement(_LoaderGhostCard.default, {
      className: "pal-c-BannerMedia__Loader",
      style: {
        '--pal-loaderghost-card-height-sm': loaderHeightSm,
        '--pal-loaderghost-card-height-md': loaderHeightMd,
        '--pal-loaderghost-card-height-lg': loaderHeightLg,
        '--pal-loaderghost-card-height-xl': loaderHeightXl
      }
    }));
  }

  /** Object for full click */
  let formattedActionFullyClick;

  /** Image and Text checks for header and body */
  const hasImage = backgroundMedia || externalMedia;
  const hasText = actionGroups || body || eyebrow || headline || tag;

  /** Text variables */
  const isKnockoutLink = textColor === 'content-knockout';
  let updatedTextPosition = textPosition.toLowerCase(); // Update the text position from DXL to be all lowerCase
  const textAlignment = updatedTextPosition === 'center-center' || updatedTextPosition === 'center' ? 'center' : 'left';

  /** Action check for formatters */
  const paletteOneAction = actionGroups && actionGroups.actions?.length === 1;
  const hasOneAction = fullyClickableParent || paletteOneAction;
  const fullyClickAction = actionGroups && actionGroups.actions[0];
  const fullyClickType = actionGroups && actionGroups.types;
  if (paletteOneAction) {
    formattedActionFullyClick = (0, _actionFormatter.actionFormatter)({
      action: fullyClickAction,
      types: fullyClickType,
      derivedAriaLabel: actionGroups?.actions[0].label,
      hasOneAction: hasOneAction,
      fullyClickableParent: paletteOneAction
    }, {
      getButtonMarkup: _getButtonHtml.getButtonHtml,
      getLinkMarkup: _getLinkHtml.getLinkHtml
    });
  }
  const componentClassName = (0, _classnames.default)('pal-c-BannerMedia', {
    [`pal-c-BannerMedia__contentAlign--${updatedTextPosition}`]: updatedTextPosition,
    [`pal-c-BannerMedia--oneAction`]: hasOneAction,
    'pal-c-BannerMedia--borderColor': borderColor,
    'pal-c-BannerMedia__corners--rounded': cornerRadius,
    [`pal-c-BannerMedia__elevation--${elevation}`]: elevation
  });
  const containerStyle = {
    ...(borderColor && {
      '--borderColor': `var( --pal-colors-default-${borderColor} )`
    }),
    ...(cornerRadius && {
      '--cornerRadius': `var( --pal-${cornerRadius} )`
    })
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    style: containerStyle
  }, hasOneAction && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formattedActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(formattedActionFullyClick)), externalActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalActionFullyClick))), hasImage && /*#__PURE__*/_react.default.createElement(_BannerHeader.default, {
    externalMedia: externalMedia,
    backgroundMedia: {
      desktopImage: backgroundMedia?.image,
      tabletImage: backgroundMedia?.tabletImage,
      mobileImage: backgroundMedia?.mobileImage,
      altText: backgroundMedia?.altText,
      loading: backgroundMedia?.loading
    }
  }), hasText && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerMedia__mainContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerMedia__body"
  }, /*#__PURE__*/_react.default.createElement(_BannerBody.default, {
    tag: tag,
    eyebrow: eyebrow,
    headline: headline,
    headlineTag: headlineTag,
    headlineStyle: "headline-lg",
    body: body,
    bodyStyle: "body-lg",
    bulletedList: bulletedList,
    textAlign: textAlignment,
    textPosition: updatedTextPosition,
    textColor: textColor
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-BannerMedia__actions"
  }, /*#__PURE__*/_react.default.createElement(_BannerFooter.default, _extends({}, actionGroups, {
    externalAction: externalAction,
    isKnockoutLink: isKnockoutLink,
    textAlignment: textAlignment
  })))));
};

/**
 * Property type definitions
 * @typedef BannerMediaProps
 * @type {object}
 * @property {object} actionGroups - Allows passing an object to the actionGroup prop
 * @property {object} backgroundMedia - desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
 * @property {string} body - body text/description of the hero body
 * @property {array} bulletedList - array of bulleted list items
 * @property {string} cornerRadius - Sets the border radius of the banner container
 * @property {object} externalAction - external action object
 * @property {object} externalMedia - brings in the UltaAsset
 * @property {string} eyebrow - smaller text above the headline
 * @property {string} headline - headline text of the hero body
 * @property {string} headlineTag - headline tag of the hero body
 * @property {boolean} isLoading - To show the loading state of the component.
 * @property {string} loaderHeightLg - The height of the loader on LG inflections (ex - "11rem")
 * @property {string} loaderHeightMd - The height of the loader on MD inflections (ex - "11rem")
 * @property {string} loaderHeightSm - The height of the loader on SM inflections (ex - "11rem")
 * @property {string} loaderHeightXl - The height of the loader on XL inflections (ex - "11rem")
 * @property {object} tag - tag component above the eyebrow
 * @property {string} textColor - sets the color of the text to default or knockout
 * @property {string} textPosition - aligns the content to 'top-left', 'center-left', 'bottom-left', 'center', or 'right'
 * @property {string} borderColor - The border color of the banner.
 * @property {('low'|'medium'|'high')} elevation - The elevation (box-shadow) of the banner.
 */
exports.BannerMedia = BannerMedia;
const propTypes = exports.propTypes = {
  /**
   * Allows passing an object to the actionGroups prop
   */
  actionGroups: _propTypes.default.object,
  /**
   * desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
   */
  backgroundMedia: _propTypes.default.object,
  /**
   * body text/description of the hero body
   */
  body: _propTypes.default.string,
  /**
   * array of bulleted list items
   */
  bulletedList: _propTypes.default.array,
  /**
   * Sets the border radius of banner container
   */
  cornerRadius: _propTypes.default.string,
  /**
   * Sets the primary action from an external source that contains business logic
   */
  externalAction: _propTypes.default.object,
  /**
   * Brings in the UltaAsset
   */
  externalImage: _propTypes.default.object,
  /**
   * Smaller text above the headline
   */
  eyebrow: _propTypes.default.string,
  /**
   * headline text of the hero body
   */
  headline: _propTypes.default.string,
  /**
   * HTML tag for the headline
   */
  headlineTag: _propTypes.default.string,
  /**
   * To show the loading state of the component.
   */
  isLoading: _propTypes.default.bool,
  /**
  * The height of the loader on LG inflections (ex - "11rem")
   */
  loaderHeightLg: _propTypes.default.string,
  /**
   * The height of the loader on MD inflections (ex - "11rem")
   */
  loaderHeightMd: _propTypes.default.string,
  /**
   * The height of the loader on SM inflections (ex - "11rem")
   */
  loaderHeightSm: _propTypes.default.string,
  /**
   * The height of the loader on XL inflections (ex - "11rem")
   */
  loaderHeightXl: _propTypes.default.string,
  /**
   * tag component above the eyebrow
   */
  tag: _propTypes.default.object,
  /**
   * Sets the color of the text to default or knockout
   */
  textColor: _propTypes.default.oneOf(['content-default', 'content-knockout']),
  /**
   * Aligns the content to left or center
   */
  textPosition: _propTypes.default.oneOf(['top-left', 'center-left', 'bottom-Left', 'center', 'right']),
  /*
    * The border color of the banner.
  */
  borderColor: _propTypes.default.string,
  /*
  * The elevation (box-shadow) of the banner.
  */
  elevation: _propTypes.default.oneOf(['low', 'medium', 'high'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} cornerRadius - cornerRadius: undefined - sets the default border radius of the banner
 * @property {string} headlineTag - headlineTag: 'h2' - sets the default for the headline tag
 * @property {string} textColor - textColor: 'content-default'- sets the color of the text to content-default or content-knockout
 * @property {string} textPosition - textPosition='top-left'' - The default textPosition setting
 * @property {string} elevation - Shadow elevation level (low, medium, high).
 * @property {string} borderColor - Border color from design tokens (any border color).
 * @property {boolean} isLoading=false - Set default isLoading to false
 */
const defaultProps = exports.defaultProps = {
  cornerRadius: undefined,
  headlineTag: 'h2',
  textColor: 'content-default',
  textPosition: 'top-left',
  elevation: undefined,
  borderColor: undefined,
  isLoading: false
};
BannerMedia.propTypes = propTypes;
var _default = exports.default = BannerMedia;